import { useEffect, useState } from "react";
import i18n from "@/languages/index";
import useLangs from "@/languages/hooks/useLangs";

const useLanguageProvider = () => {
  const [loaded, setLoaded] = useState(false);
  const [isFetching, setIsFetching] = useState(true);

  const { 
    checkLangAvailable,
    changeLang
  } = useLangs();

  useEffect(() => {

    // Handle the initial browser language
    changeLang(i18n.language);
  }, []);

  useEffect(() => {
    if (checkLangAvailable(i18n.language)) {
      setLoaded(true);
      setIsFetching(false);
    }
  }, [i18n.language]);


  return {
    loaded,
    isFetching,
  }
}

export default useLanguageProvider;